import { OreDivider, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { PageWrapper } from '@/Shared/ui/layout'
import { StoreContactsList } from '@/Store/ui/organisms'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { useUserData } from '@/User/ui/context'

export const StoreContactsPage = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()

  return (
    <PageWrapper
      paddingSmaller
      paddingTop={8}
      style={{
        paddingRight: 40,
        paddingLeft: 40,
        minWidth: '-webkit-fill-available',
        marginRight: 0,
        marginLeft: 0,
      }}
    >
      <OreHeading as="h1" size="title-sm">
        {t(storesTranslation.contacts.pageTitle)}
      </OreHeading>
      <OreDivider space="larger-bottom" />
      {merchant.isNursery ? (
        <OreStack placeContent="stretch" space="large">
          <OreText>{t(storesTranslation.contacts.desc)}</OreText>
          <StoreContactsList />
          <OreText>
            {t(storesTranslation.contacts.legend)}
            <a href={`mailto:${t(storesTranslation.contacts.legendEmail)}`}>
              {t(storesTranslation.contacts.legendEmail)}
            </a>
          </OreText>
        </OreStack>
      ) : (
        <StoreContactsList />
      )}
    </PageWrapper>
  )
}
